import { render, staticRenderFns } from "./MantenedorProveedores.vue?vue&type=template&id=2aa94865&"
import script from "./MantenedorProveedores.vue?vue&type=script&lang=ts&"
export * from "./MantenedorProveedores.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorProveedores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports